import React from 'react';
import { options, stateClass, stateText } from '../../drift/actionModel';

// What a person can do about a plan: queue its test (the dry run) or its apply (the change). Each is a person's decision and is audited by the
// API; this only offers what has not been queued yet. Queuing a job is where the plan's work ends: nothing reads the job back.
//   busy  something is being changed: the buttons wait
export default function PlanActions({ plan, busy, onApprove }) {
  const can = options(plan);
  return (
    <span className="plan-actions">
      <span className={`pill ${stateClass(plan.state)}`} aria-label="Plan state">{stateText(plan.state)}</span>
      {can.test && <button type="button" className="btn btn-sm" disabled={busy} onClick={() => onApprove('test')}>Test</button>}
      {can.apply && <button type="button" className="btn btn-primary btn-sm" disabled={busy} onClick={() => onApprove('apply')}>Apply</button>}
    </span>
  );
}
